import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-edit-field-modal',
  templateUrl: './edit-field-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-field-modal.component.scss']
})
export class EditFieldModalComponent {
  public fieldForm: FormGroup
  public isSuccess : boolean = false
  public isLoading : boolean = false

  constructor(
    public dialogRef: MatDialogRef<EditFieldModalComponent>,
    @Inject(MAT_DIALOG_DATA) public fieldData: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private wellHeaderInfoService : WellHeaderInfoService
    ) { }

  ngOnInit() {
    this.fieldForm = this.initializeForm()

    this.fieldForm.get('fieldShortName')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        this.fieldForm.get('fieldShortName')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
  }

  initializeForm(){
    return this.fb.group({
      id: this.fieldData.fieldId,
      regionId: this.fieldData.pscId,
      fieldLongName: [this.fieldData.longName, [Validators.required, noWhitespaceValidator()]],
      fieldShortName: [this.fieldData.name, [Validators.required, noWhitespaceValidator()]],
      fieldDescription: '',
      fieldStatus: this.fieldData.status,
      region: this.fieldData.region,
      blockName: this.fieldData.block,
      basinName: '',
      basinType: '',
      remark: this.fieldData.remarks,
    })
  }

  updateField() {
    this.wellHeaderInfoService.updateFields(this.fieldForm.value).subscribe(
      {
        next: (res) => {
          if(res.isSuccess){
            this.isSuccess = true
            this.closeDialog()
          }

          this.isLoading = false
        },
        error: (err) => this.isLoading = false
      }
    )  
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get fieldLongName() {
    return this.fieldForm.get('fieldLongName');
  }

  get fieldShortName() {
    return this.fieldForm.get('fieldShortName');
  }
}
